//This component will show filters in the UI (popup)
import React from "react";
import { connect } from "react-redux";
import { activateDatadic } from "../redux";
import "../css/Filterprint.css";
import reqwest from "reqwest";
import { Checkbox, Row, Col, Divider,Popover  } from "antd";

class FilterprintC extends React.Component {
  state = {
    data: [],
    ColchkS: [],
    cid: this.props.cid,
  };

  onChange = (e) => {
   
    if (this.props.datadic.FilterDic.columns[e.target.id].selectedUI == 1) {
      this.props.datadic.FilterDic.columns[e.target.id].selectedUI = "0";
     // this.props.datadic.FilterDic.columns[e.target.id].selected = "0";
      if (this.props.datadic.FilterDic.columns[e.target.id].value == "") {
        
        if (  String(this.props.datadic.FilterDic.columns[e.target.id].min).trim() !=''   &&  String(this.props.datadic.FilterDic.columns[e.target.id].max).trim() !='') {
         
        this.props.datadic.FilterDic.columns[e.target.id].value = [
          this.props.datadic.FilterDic.columns[e.target.id].min,
          this.props.datadic.FilterDic.columns[e.target.id].max,
        ];
      }
        if (
          this.props.datadic.FilterDic.columns[e.target.id].type ==
          "bubbleSlider"
        ) {
          this.props.datadic.FilterDic.columns[e.target.id].value = [
            "A",
            "B",
            "C",
            "D",
            "F",
            "NA",
          ];
        }
      }
    } else {
      
      this.props.datadic.FilterDic.columns[e.target.id].selectedUI = "1";
     // this.props.datadic.FilterDic.columns[e.target.id].selected = "1";
      if (this.props.datadic.FilterDic.columns[e.target.id].value == "") {
       
        if (  String(this.props.datadic.FilterDic.columns[e.target.id].min).trim() !=''   &&  String(this.props.datadic.FilterDic.columns[e.target.id].max).trim() !='') {
         
        this.props.datadic.FilterDic.columns[e.target.id].value = [
          this.props.datadic.FilterDic.columns[e.target.id].min,
          this.props.datadic.FilterDic.columns[e.target.id].max,
        ];
      }
        if (
          this.props.datadic.FilterDic.columns[e.target.id].type ==
          "bubbleSlider"
        ) {
          this.props.datadic.FilterDic.columns[e.target.id].value = [
            "A",
            "B",
            "C",
            "D",
            "F",
            "NA",
          ];
        }
      }
    }
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
  };


  getCatNamesend(d){

 var g= '';

  this.props.datadic.FilterDic.groupingColumns.map((experience, i) => {
 
        if (experience.id==d){
          
          g= experience.name_
        }
  });



 
return g ;

  }


  render() {
    console.log(this.props.searchv)
    const style = { paddingRight: "10px", width: "400px" };
    var Categories = [];
    var CatType = [];
   // var CatTypeA = [];
   // var CategoriesId = [];
    var Colchk = [];
    var Coldefin = [];
    var ColTabid= [];
    var ColFid= [];
   

    var p = 0;
    var a = 0;
    if (this.props.datadic.FilterDic != undefined) {
      this.props.datadic.FilterDic.columns.map((experience, i) => {

        if (this.props.cid == this.props.datadic.FilterDic.columns[i].tabId) {
          if (this.props.datadic.FilterDic.columns[i].label != "Industry"   ) {

            Coldefin[i]=this.props.datadic.FilterDic.columns[i].definition;
            Categories[i] = this.props.datadic.FilterDic.columns[i].colEnName;
            CatType[i] =this.props.datadic.FilterDic.columns[i].typeCol.toLowerCase();
            ColTabid[i]=this.props.datadic.FilterDic.columns[i].tabId;
            ColFid[i]=this.props.datadic.FilterDic.columns[i].groupId;
         
            

           /*  if (this.props.datadic.FilterDic.columns[i].typeCol == "Absolute") {
              CatTypeA[i] = this.props.datadic.FilterDic.columns[i].colEnName;
            } */
           // CategoriesId[i] = this.props.datadic.FilterDic.columns[i].tabId;
            if (this.props.datadic.FilterDic.columns[i].selectedUI == "1") {
              Colchk[i] = true;
            } 
            if (this.props.datadic.FilterDic.columns[i].selectedUI == "0") {
              Colchk[i] = false;
            }

             if (this.props.datadic.FilterDic.columns[i].typeCol.toLowerCase()=='absolute'){
               
              if (this.props.datadic.FilterDic.columns[i].selectedUI == "1" && this.props.datadic.FilterDic.columns[i-1].selectedUI == "1" ) {
                Colchk[i-1] = false;
              }  
             }
           
       


          }
        }
     
      });

    }
    
   //. console.log('ARRRRRRRR',Colchk)
    return (
      <div>
        <Row
          className=" "
          justify="start"
          /* className={
                CatType[index] != "percentile" && CatType[index] != "absolute"
                  ? ""
                  : "bcolor"
              } */
              style={{rowGap: '12px',fontWeight: 600}}
              
        >
         
          {Categories.map((name, index) => (


         
            <div className={ColTabid[index] ==3  &&  ColFid[index]!=ColFid[index+1]? 'Colm' :''} >
            
           

              {CatType[index] == "percentile" && Colchk[index+1]==false &&  ColTabid[index] !=3 ? (
                <Col span={36} className={"gutter-row mbox" + this.state.cid}> 
                  <Checkbox
                    style={style}
                    checked={Colchk[index]}
                    id={index}
                    onChange={this.onChange}
                  >
                    <Popover content={Coldefin[index]} title={name} placement="right"> {name}</Popover>{" "}
                  </Checkbox>{" "}
                </Col>
              ) : (
                ""
              )}




{ColTabid[index] ==3  &&  ColFid[index]!=ColFid[index-7]? <Divider  style={{borderTopColor:'rgb(0 0 0 / 5%)',fontStyle:'oblique'}}  >
{ColFid[index]!=ColFid[index-1]?
      this.getCatNamesend(ColFid[index])
   :''} 
      </Divider>:''}
 
{/* 
{ColTabid[index] ==3  &&  ColFid[index]!=ColFid[index-1]  ? (
               
                
               <Col span={36} push={14} > 
          
             xxxxxxxxxxxxxxxxxxxxxxxxxx
           </Col>
          
         ) : (
           ""
         )} */}






              {CatType[index] == "percentile" && Colchk[index+1]==false &&  ColTabid[index] ==3   ? (
               
                
                    <Col span={36} className={"gutter-row mbox" + this.state.cid}>  
               
                  <Checkbox
                    style={style}
                    checked={Colchk[index]}
                    id={index}
                    onChange={this.onChange}
                  >
                    <Popover content={Coldefin[index]} title={name} placement="right"> {name}</Popover>{" "}
                  </Checkbox>{" "}
                </Col>
               
              ) : (
                " "
              )}


             


              {CatType[index] == "absolute" && Colchk[index] == true ? (
                <Col span={36} className={"gutter-row mbox" + this.state.cid}> 
                  <Checkbox
                    style={style}
                    checked={Colchk[index]}
                    id={index}
                    onChange={this.onChange}
                  >
                   <Popover content={Coldefin[index]} title={name} placement="right">{name}{" "}</Popover> 
                  </Checkbox>{" "}
                </Col>
              ) : (
                ""
              )}  
 
           

{/*  {ColTabid[index] ==3  &&  ColFid[index]!=ColFid[index+1]? <Divider  style={{borderTopColor:'rgb(0 0 0 / 5%)'}}  >   </Divider>:''} */}

              {CatType[index] != "percentile" &&
              CatType[index] != "absolute" ? (
                <Col span={36} className={"gutter-row mbox" + this.state.cid}>
                  <Checkbox
                    style={style}
                    checked={Colchk[index]}
                    id={index}
                    onChange={this.onChange}
                  >
                   <Popover content={name=="Sector"?Coldefin[0]+Coldefin[1]:Coldefin[index]} title={name=="Sector"?'Sector/Industry':name} placement="right"> {name=="Sector"?'Sector/Industry':name} </Popover>{" "}
                  </Checkbox>{" "}
                </Col>
              ) : (
                ""
              )}
      

            </div> 
         ))}


        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  datadic: state.datadic,
});

const mapDispatchToProps = {
  activateDatadic,
};

const Filterprint = connect(mapStateToProps, mapDispatchToProps)(FilterprintC);

export default Filterprint;
